import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Heart, X } from "lucide-react";

export function InterestModal({ isOpen, onClose, profileName = "இந்த உறுப்பினர்", onSuccess }) {
  const [message, setMessage] = useState("");
  const [interestSent, setInterestSent] = useState(false);

  const handleSendInterest = () => {
    // Normally, you'd send the interest to your backend here
    setInterestSent(true);
    if (onSuccess) onSuccess();

    setTimeout(() => {
      onClose();
      setInterestSent(false);
      setMessage("");
    }, 2000);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Heart className="h-5 w-5 text-red-500" />
            {interestSent ? "ஆர்வம் அனுப்பப்பட்டது!" : "ஆர்வம் தெரிவிக்கவும்"}
          </DialogTitle>
        </DialogHeader>

        {!interestSent ? (
          <div className="space-y-4">
            <p className="text-muted-foreground">
              {profileName} அவர்களுக்கு உங்கள் ஆர்வத்தை தெரிவிக்க விரும்புகிறீர்களா?
            </p>

            <div className="space-y-2">
              <Label htmlFor="interest-message">செய்தி (விருப்பம்)</Label>
              <Textarea
                id="interest-message"
                placeholder="உங்கள் செய்தியை இங்கே எழுதுங்கள்..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={3}
              />
            </div>

            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={onClose}>
                <X className="h-4 w-4 mr-2" />
                ரத்து செய்யவும்
              </Button>
              <Button onClick={handleSendInterest} className="bg-red-500 hover:bg-red-600">
                <Heart className="h-4 w-4 mr-2" />
                ஆர்வம் அனுப்பவும்
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center py-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="h-8 w-8 text-green-600" />
            </div>
            <p className="text-green-600 font-medium">
              உங்கள் ஆர்வம் வெற்றிகரமாக அனுப்பப்பட்டது!
            </p>
            <p className="text-muted-foreground text-sm mt-2">
              {profileName} அவர்களுக்கு அறிவிப்பு அனுப்பப்பட்டுள்ளது.
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
